import { marked } from 'marked';
import DOMPurify from 'dompurify';

function sanitizeMarkdownHtml(html: string): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';

  const withLinkTargets = html.replace(
    /<a\s+(?:[^>]*?\s+)?href="([^"]*)"([^>]*)>/g,
    (_match, href: string, rest: string) => {
      const isInternal =
        href.startsWith('/') ||
        href.startsWith('#') ||
        (!!origin && href.startsWith(origin));
      return isInternal
        ? `<a href="${href}"${rest}>`
        : `<a href="${href}" target="_blank" rel="noopener noreferrer"${rest}>`;
    },
  );

  return DOMPurify.sanitize(withLinkTargets, {
    ADD_ATTR: ['target', 'rel'],
  });
}

/**
 * Convert markdown to sanitized HTML. All agent-generated markdown MUST go
 * through this helper before dangerouslySetInnerHTML — the model output is
 * untrusted. Internal app links (relative, in-page anchors, or same-origin,
 * e.g. links to a project card or board) navigate in the SAME tab like a
 * normal link; only external cross-origin links open in a new tab.
 */
export function markdownToSafeHtml(markdown: string): string {
  return sanitizeMarkdownHtml(marked.parse(markdown) as string);
}

/** Sanitized inline markdown for compact, single-line model output. */
export function markdownToSafeInlineHtml(markdown: string): string {
  return sanitizeMarkdownHtml(marked.parseInline(markdown) as string);
}
